export default __webpack_public_path__ + "static/media/2.242ae5e9.jpg";